import '../css/home.css';
import Sidebar from './sidebar';
import { useEffect, useState} from 'react';
import {  useNavigate } from "react-router-dom";
import { BsPencilSquare } from "react-icons/bs";
import {RiDeleteBin4Fill } from "react-icons/ri";
import Collapsible from 'react-collapsible';

export default function Dashboard(){
    const Navigate=useNavigate()
    const [users,Setusers]=useState([]);


  	const handleLogout = () => {
      
		localStorage.clear();
		Navigate("/");
	};



    const gottonext=()=>{
Navigate("/form")
    }






  
      const getUsers =async() => {
          const response =  await fetch('https://storcarrd.herokuapp.com/data' ,  {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "authentication": localStorage.getItem("token"),
              "auth":localStorage.getItem("email")
            },
          });
          Setusers(await response.json());
     
      }
         useEffect(()=> {
         
             getUsers();
            
         },[]);

         const deletecard=async(id)=>{
          const res= await fetch(`https://storcarrd.herokuapp.com/posts/${id}`,{
             method: "DELETE", 
             headers: {
               Accept: "application/json",
               "Content-Type": "application/json",
               "authentication": localStorage.getItem("token"),
               "auth":localStorage.getItem("email")
             },
           })
           const data=await res.json()
           getUsers()
           console.log(data)
         }


     
      return(
  <>
<header className="header">
<div className='headside'><Sidebar/></div>

<button className='logout' onClick={handleLogout}>
                   Logout
               </button>
</header>
<div id="secondsection">
<div id="secondsectionfirstpart"> 
<button className='wasnt' onClick={gottonext}>
                   Add cards
               </button>

</div>
{


   users.map(Elem=>{

               return (  
<div id="secondsectionfirstpart">


<Collapsible  className="collapsible"  trigger={Elem.card}>

<div className="content">
<button type="button" className='moddel' onClick={()=>deletecard(Elem._id)}><RiDeleteBin4Fill/></button>
  <button type="button" className='moddel' ><BsPencilSquare/></button>

  <span style={{color:"red"}}>NAME:</span><span style={{color:"green"}}>{Elem.name}</span><br></br>
  <span style={{color:"red"}}>CARD NUMBER:</span><span style={{color:"green"}}>{Elem.cardnumber}</span><br></br>
  <span style={{color:"red"}}>EXPIRY:</span><span style={{color:"green"}}>{Elem.expirymm}/{Elem.expiryyy}</span><br></br>
  <span style={{color:"red"}}>CVV:</span><span style={{color:"green"}}>{Elem.cvv}</span>
          
</div>
</Collapsible>
</div>
           )
          })
            }

</div>





  </> 
      )
  }
  
